module.exports = __webpack_public_path__ + "static/media/halal2.db5ada77.png";